module.exports = __webpack_public_path__ + "./images/copy.e3be72cef96746d7d2660758ef40ab0d.png";